import React from 'react';
import { Outlet } from 'react-router-dom';
import './PublicLayout.css';

const SHOW_DEMO_BANNER = String(process.env.REACT_APP_SHOW_DEMO_BANNER || '').toLowerCase() === 'true';
const DEMO_BANNER_TEXT =
  process.env.REACT_APP_DEMO_BANNER_TEXT ||
  'Demo data: rankings shown here are for testing only and are not official Olympic qualification data.';

const PublicLayout = () => {
  const year = new Date().getFullYear();

  return (
    <div className="public-root">
      {SHOW_DEMO_BANNER && (
        <div className="public-demo-banner" role="status">
          {DEMO_BANNER_TEXT}
        </div>
      )}
      <header className="public-header">
        <div className="public-header-inner">
          <a
            href="https://www.igfgolf.org/olympic-games/2028/los-angeles-2028"
            target="_blank"
            rel="noopener noreferrer"
            className="public-brand"
            aria-label="International Golf Federation - Los Angeles 2028"
          >
            <img
              src={`${process.env.PUBLIC_URL || ''}/igf-logo.png`}
              alt="International Golf Federation"
              className="public-brand-logo"
            />
          </a>
        </div>
      </header>

      <main className="public-main">
        <Outlet />
      </main>

      <footer className="public-footer">
        <div className="public-footer-grid">
          <div className="public-footer-brand-col">
            <div className="public-social" aria-label="Social links">
              <a href="https://www.facebook.com/igfgolf" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <i className="bi bi-facebook" />
              </a>
              <a href="https://x.com/igfgolf" target="_blank" rel="noopener noreferrer" aria-label="X">
                <i className="bi bi-twitter-x" />
              </a>
              <a href="https://www.instagram.com/igfgolf" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <i className="bi bi-instagram" />
              </a>
              <a href="https://www.linkedin.com/company/international-golf-federation" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <i className="bi bi-linkedin" />
              </a>
            </div>
          </div>

          <div className="public-footer-links-col">
            <h4>Rankings</h4>
            <ul>
              <li>
                <a
                  href="https://www.igfgolf.org/olympic-games/2028/los-angeles-2028"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Olympic Golf Rankings
                </a>
              </li>
            </ul>
          </div>

          <div className="public-footer-links-col">
            <h4>Qualification</h4>
            <ul>
              <li>
                <a href="https://www.igfgolf.org/pdf/la2028/glf-la28-qualification-system.pdf" target="_blank" rel="noopener noreferrer">
                  How it works
                </a>
              </li>
            </ul>
          </div>

          <div className="public-footer-links-col">
            <h4>About IGF</h4>
            <ul>
              <li>
                <a href="https://www.igfgolf.org/" target="_blank" rel="noopener noreferrer">
                  IGF website
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="public-footer-bottom">
          <p>© {year} International Golf Federation. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default PublicLayout;
